import { createSlice } from '@reduxjs/toolkit';
// import { message as toaster } from 'antd';
import { API } from 'api';

const initialState = {};

export const projectSlice = createSlice({
	name: 'projectState',
	initialState,
	reducers: {},
});

export const addProject =
	({ data, setErrors, isEditMode }) =>
	async () => {
		let urlType;
		if (isEditMode) {
			urlType = '/update';
		} else {
			urlType = '/create';
		}
		console.log('data', data);
		console.log('setErrors', setErrors);
		const CREDENTIALS = {
			url: urlType,
			data,
			setErrors,
		};

		return API.common(CREDENTIALS).then((res) => {
			// toaster.success('Project added successfully');
			console.log('res', res);
			return true;
		});
	};

export const deleteTrip =
	({ id }) =>
	async () => {
		const urlType = '/update';
		console.log(id);
		const CREDENTIALS = {
			url: urlType,
			data: {
				update_type: 'delete_trip',
				data: {
					trip_id: id,
					soft_delete: true,
				},
			},
		};

		return API.common(CREDENTIALS).then((res) => {
			console.log(res);
			window.location.reload();
		});
	};

export default projectSlice.reducer;
